const nativeLog = console.log;
const nativeError = console.error;
console.log = function () {
    let argv = arguments;
    let date = new Date();
    (function () {
        nativeLog(`${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}--->`, ...argv)
        argv = null;
        date = null
    } ())
}
console.error = function () {
    let argv = arguments;
    let date = new Date();
    (function () {
        nativeError(`${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}--->`, ...argv)
        argv = null;
        date = null
    } ())
}
